/**
 * 状态**文案**的唯一来源。
 *
 * 注意这里只管文字，不管颜色 —— 颜色统一在 `styles/tokens.css` 的 `--status-*-{fg,bg}`。
 * 早先这里还带 antd 预设色名与十六进制值，改造后已删除，原因有二：
 *   1. antd 预设色是 antd 自己的语义，与运行状态对不齐（SKIPPED 在 antd 里没有对应物），
 *      且深浅两套的取值不受我们控制；
 *   2. 留着一份没人读的字面色值，下一个人看到就会拿去用，硬编码就是这么回潮的。
 * 需要状态色请用令牌，需要状态文字才来这里。
 */

import type { NodeStatus, RunStatus } from '@/types/api';

export interface StatusMeta {
  label: string;
}

export const RUN_STATUS_META: Record<RunStatus, StatusMeta> = {
  QUEUED: { label: '排队中' },
  RUNNING: { label: '执行中' },
  SUCCESS: { label: '成功' },
  FAILED: { label: '失败' },
  CANCELLING: { label: '取消中' },
  CANCELLED: { label: '已取消' },
};

export const NODE_STATUS_META: Record<NodeStatus, StatusMeta> = {
  PENDING: { label: '待执行' },
  RUNNING: { label: '执行中' },
  SUCCESS: { label: '成功' },
  FAILED: { label: '失败' },
  SKIPPED: { label: '已跳过' },
  TIMEOUT: { label: '超时' },
  CANCELLED: { label: '已取消' },
};

export const RUN_STATUS_OPTIONS = (Object.keys(RUN_STATUS_META) as RunStatus[]).map((v) => ({
  value: v,
  label: RUN_STATUS_META[v].label,
}));

export function isRunTerminal(s: RunStatus | null | undefined): boolean {
  return s === 'SUCCESS' || s === 'FAILED' || s === 'CANCELLED';
}
